import { RedAsterisk } from '../input';
import { StyledTooltipIcon } from '../select/styled';
import { theme } from '../theme';
import { Tooltip } from '../tooltip';
import { Slider, SliderProps } from './Slider';
import { StyledInputLabel, StyledSliderWithLabel } from './styled';

export interface SliderWithLabelProps extends SliderProps {
  label: React.ReactNode;
  labelTooltip?: React.ReactNode;
}

export const SliderWithLabel: React.FC<SliderWithLabelProps> = ({
  label,
  labelTooltip,
  ...props
}) => (
  <StyledSliderWithLabel>
    <StyledInputLabel disabled={props.disabled}>
      {label}
      {props.required && <RedAsterisk />}
      {labelTooltip && (
        <Tooltip
          placement="topRight"
          title={labelTooltip}
          color={theme.colors.primaryK10}>
          <StyledTooltipIcon />
        </Tooltip>
      )}
    </StyledInputLabel>
    <Slider {...props} />
  </StyledSliderWithLabel>
);
